(() => {
  const selector = '[data-armor-proof-media-v2]';
  const controllers = new WeakMap();
  const youtubeIdPattern = /^[A-Za-z0-9_-]{11}$/;

  class ArmorProofMediaV2 {
    constructor(root) {
      this.root = root;
      this.handleClick = this.handleClick.bind(this);
      this.root.addEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const button = event.target.closest('[data-armor-proof-load]');
      if (!button || !this.root.contains(button)) return;

      const video = button.closest('[data-armor-proof-video]');
      const player = video?.querySelector('[data-armor-proof-player]');
      const panel = video?.querySelector('[data-armor-proof-load-panel]');
      const status = video?.querySelector('[data-armor-proof-status]');
      const videoId = video?.dataset.videoId || '';
      const videoTitle = video?.dataset.videoTitle || 'Armor-Dilloz source video';

      if (
        !video ||
        !player ||
        !panel ||
        !status ||
        !youtubeIdPattern.test(videoId) ||
        video.dataset.videoLoaded === 'true'
      ) {
        return;
      }

      button.disabled = true;

      const iframe = document.createElement('iframe');
      iframe.className = 'armor-proof-media-v2__iframe';
      iframe.title = `YouTube player: ${videoTitle}`;
      iframe.src =
        `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}` +
        '?autoplay=0&cc_load_policy=1&playsinline=1&rel=0';
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allow = 'encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;

      video.dataset.videoLoaded = 'true';
      panel.hidden = true;
      player.appendChild(iframe);
      status.textContent =
        'Video player loaded. Playback remains stopped. Use the player play control to begin.';
    }

    destroy() {
      this.root.removeEventListener('click', this.handleClick);
      this.root.querySelectorAll('.armor-proof-media-v2__iframe').forEach((iframe) => {
        iframe.remove();
      });
      this.root.querySelectorAll('[data-armor-proof-video]').forEach((video) => {
        delete video.dataset.videoLoaded;
        const panel = video.querySelector('[data-armor-proof-load-panel]');
        const button = video.querySelector('[data-armor-proof-load]');
        const status = video.querySelector('[data-armor-proof-status]');
        if (panel) panel.hidden = false;
        if (button) button.disabled = false;
        if (status) status.textContent = '';
      });
    }
  }

  function initialize(container = document) {
    const roots = [];
    if (container.matches?.(selector)) roots.push(container);
    container.querySelectorAll?.(selector).forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (!controllers.has(root)) {
        controllers.set(root, new ArmorProofMediaV2(root));
      }
    });
  }

  function unload(container) {
    const roots = [];
    if (container.matches?.(selector)) roots.push(container);
    container.querySelectorAll?.(selector).forEach((root) => roots.push(root));

    roots.forEach((root) => {
      const controller = controllers.get(root);
      if (!controller) return;
      controller.destroy();
      controllers.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
